{
  "chooseFolder": "Choose a folder…",
  "chosen_one": "{{name}} · {{count}} file",
  "chosen_other": "{{name}} · {{count}} files",
  "prompt": "Drop a file or a folder here, or click to choose files",
  "remove": "Remove",
  "severalFiles": "Several files"
}
